export enum CreateQuestionGroupPanelOptions {
  None = 0,
  CreateQuestionGroup = 1,
  EditQuestionGroup = 2,
  CreateQuestion = 3,
  EditQuestion = 4
}
